"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Lg = function Lg(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.287 6.714a5.286 5.286 0 1 0 0 10.572 5.287 5.287 0 0 0 0-10.572zm0 .86c.05 0 .156 0 .21.002v.413a14.621 14.621 0 0 0-.21-.003 3.986 3.986 0 0 0-2.836 1.175 3.982 3.982 0 0 0-1.175 2.836c0 1.072.417 2.08 1.175 2.836a3.986 3.986 0 0 0 2.836 1.175 4.019 4.019 0 0 0 4.003-3.741v-.06H6.552v-.41h2.981l.177-.001v.201a4.394 4.394 0 0 1-1.294 3.128 4.4 4.4 0 0 1-3.13 1.296c-1.18 0-2.291-.46-3.13-1.296a4.394 4.394 0 0 1-1.293-3.128 4.43 4.43 0 0 1 4.424-4.425zm16.062.878c-2.21 0-3.372 1.207-3.372 3.508 0 2.29 1.05 3.53 3.361 3.53 1.06 0 2.098-.27 2.662-.665v-3.316h-2.74v1.274h1.285v1.195c-.237.09-.699.181-1.139.181-1.42 0-1.895-.722-1.895-2.188 0-1.398.451-2.222 1.872-2.222.79 0 1.241.248 1.613.722l.982-.902c-.598-.857-1.647-1.117-2.629-1.117zm-8.413.102v6.834h4.85v-1.33h-3.27V8.553zM3.599 9.677a.635.635 0 1 1 0 1.27.635.635 0 0 1 0-1.27zm1.478.002h.42v4.22h1.052v.414H5.077z"
  }));
};

Lg.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Lg.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Lg;
exports.default = _default;